import { PersistenceSerializationError } from './persistenceErrors';

/**
 * @typedef {{ ok: true, value: string }} EncodeSuccess
 * @typedef {{ ok: false, error: PersistenceSerializationError }} EncodeFailure
 * @typedef {EncodeSuccess | EncodeFailure} EncodeResult
 */

/**
 * @typedef {{ ok: true, value: unknown }} DecodeSuccess
 * @typedef {{ ok: false, kind: 'missing', error: null }} DecodeMissing
 * @typedef {{ ok: false, kind: 'parse', error: SyntaxError }} DecodeParseFailure
 * @typedef {DecodeSuccess | DecodeMissing | DecodeParseFailure} DecodeResult
 */

/**
 * @param {unknown} value
 * @returns {EncodeResult}
 */
export function encode(value) {
  try {
    return { ok: true, value: JSON.stringify(value) };
  } catch (cause) {
    return {
      ok: false,
      error: new PersistenceSerializationError('Failed to serialize persistence value', {
        cause,
      }),
    };
  }
}

/**
 * @param {string | null | undefined} rawValue
 * @returns {DecodeResult}
 */
export function decode(rawValue) {
  if (rawValue === null || rawValue === undefined) {
    return { ok: false, kind: 'missing', error: null };
  }

  try {
    return { ok: true, value: JSON.parse(rawValue) };
  } catch (error) {
    return {
      ok: false,
      kind: 'parse',
      error: error instanceof SyntaxError ? error : new SyntaxError('Invalid JSON'),
    };
  }
}
